import { Link } from "react-router-dom";

import { AuthLayout } from "../components/Layout";
import { useDocumentTitle } from "../hooks/useApi";

export function NotFoundPage() {
  useDocumentTitle("Page introuvable");
  return (
    <AuthLayout
      title="Page introuvable"
      intro="Cette adresse ne correspond à aucun écran de l'application."
      footer={<Link to="/">Revenir au tableau de bord</Link>}
    >
      <p className="text-muted mb-0">
        Si vous êtes arrivé ici depuis un lien de l'application, le contenu a
        peut-être été archivé ou supprimé. Vos données restent accessibles depuis
        la page « Corbeille et archives ».
      </p>
    </AuthLayout>
  );
}
